// extracted by mini-css-extract-plugin
export default {"wrapper":"TileLink_wrapper__M2DvG","icon":"TileLink_icon__HFXq3"};